import { useLocation, Link } from "react-router-dom";
import { CheckCircle2, CalendarDays, Clock, MapPin, ArrowLeft } from "lucide-react";

export default function RegistrationSuccess() {
  const { state } = useLocation();
  const s = state?.settings || {};
  const reg = state || {};
  return (
    <div className="min-h-screen bg-[#06080F] text-white flex items-center justify-center px-5 py-16">
      <div className="max-w-2xl w-full glass p-8 sm:p-10" data-testid="registration-success-modal">
        <img src="https://customer-assets-jai6qajn.emergentagent.net/job_build-framework-27/artifacts/xu1ebv9g_MOOLAH%20LOGO.jpg" alt="Moolah Tech" className="h-14 w-14 rounded-2xl object-cover shadow-[0_0_20px_rgba(56,189,248,0.35)] mb-5"/>
        <div className="w-14 h-14 rounded-2xl bg-emerald-400/10 border border-emerald-400/30 flex items-center justify-center mb-6">
          <CheckCircle2 className="w-7 h-7 text-emerald-400"/>
        </div>
        <div className="eyebrow">Reservation received</div>
        <h1 className="text-3xl sm:text-4xl font-bold mt-2 leading-tight">Thanks, <span className="brand-gradient">{reg.first_name || "there"}</span>.</h1>
        <p className="text-slate-400 mt-3">We've received your reservation for the Moolah Tech 1-Day Vibe Coding Bootcamp.</p>

        <div className="grid sm:grid-cols-3 gap-3 mt-8">
          <Stat label="Registration #" value={reg.registration_number || "—"}/>
          <Stat label="Registration Type" value={reg.registration_type === "early_bird" ? "Early Bird" : "Regular"}/>
          <Stat label="Amount Submitted" value={`₱${reg.amount_due || "—"}`}/>
        </div>

        <div className="mt-6 space-y-3">
          <Row icon={<CalendarDays className="w-4 h-4"/>} label="Date" value="Saturday, September 26, 2026"/>
          <Row icon={<Clock className="w-4 h-4"/>} label="Time" value="8:00 AM – 12:00 NN"/>
          <Row icon={<MapPin className="w-4 h-4"/>} label="Venue" value="3rd Floor Function Hall, Tanza Municipal Building, Tanza, Cavite"/>
        </div>

        <div className="mt-8 rounded-xl border border-amber-400/30 bg-amber-400/5 px-5 py-4">
          <div className="text-amber-300 font-mono text-xs tracking-widest uppercase">Pending Payment Verification</div>
          <div className="text-sm text-slate-300 mt-1">Your seat will be officially confirmed once your payment has been reviewed.</div>
        </div>

        <Link to="/" className="cta-outline inline-flex items-center gap-2 mt-8"><ArrowLeft className="w-4 h-4"/> Back to Moolah Tech</Link>
      </div>
    </div>
  );
}
function Stat({label,value}) {
  return (
    <div className="bg-white/[0.03] border border-white/5 rounded-lg px-4 py-3">
      <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">{label}</div>
      <div className="text-white font-semibold mt-1">{value}</div>
    </div>
  );
}
function Row({icon,label,value}) {
  return (
    <div className="flex items-start gap-3">
      <div className="w-9 h-9 rounded-lg bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center text-cyan-300">{icon}</div>
      <div>
        <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">{label}</div>
        <div className="text-white text-sm">{value}</div>
      </div>
    </div>
  );
}
